import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import type { IUserMePhoneNumberChangeCompleteDto } from "@api/users/me/phoneNumberChange/complete/types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IUserMePhoneNumberChangeCompleteDto
>("users.me.phoneNumberChange.complete");

export const complete = {
  ...postApis,
};
